import { toNumber } from 'lodash'
import utils from './utils'

export default {
    buildCclonesRoute: state => {
        // let route = '/wousdat/strong_classifiers_families.json'
        const route = '/wousdat/strong_classifiers_families/detail/.json'
        const params = {
            params: {
                list_limit: 0,
                order_direction: 'desc',
                order_fields: 'id',
                conditions: { account_id: state.accountId, status: [{ '!=': 'deleted' }] }
            }
        }
        return { route, params }
    },

    buildCcloneDetailsRoute: (state, ccloneId) => {
        const route = '/wousdat/strong_classifiers_families/detail/.json'
        const params = {
            params: {
                list_limit: 0,
                conditions: { account_id: state.accountId, id: ccloneId }
            }
        }
        return { route, params }
    },

    parseCclonesData: data => {
        let _data = []
        for (const val of data) {
            if (val.strong_classifiers_family_fields.settings === null) {
                val.strong_classifiers_family_fields.settings = {
                    '3rdParty': {
                        cluster_only: val.strong_classifiers_family_fields.cluster_only == 1 ? true : false,
                        is_profile_versioned: val.strong_classifiers_family_fields.is_profile_versioned == 1 ? true : false
                    }
                }
            }
            const wamData = {
                ...val.strong_classifiers_family_fields,
                scf_raw_data_result: val.scf_raw_data_result,
                isSelectable: true,
                hasChild: false,
                parentJsonKeyName: null,
                jsonKey: {
                    name: 'cclone' + val.strong_classifiers_family_fields.id,
                    type: 'Cclone',
                    subType: 'audience_cclone',
                    ids: [toNumber(val.strong_classifiers_family_fields.id)]
                }
            }
            _data.push(wamData)
            _data = _data.sort((a, b) => a.label.localeCompare(b.label, undefined, { ignorePunctuation: true, numeric: true }))
        }
        return _data
    },

    parseUpdatedCclone: data => {
        return {
            ...data,
            isSelectable: true,
            hasChild: false,
            parentJsonKeyName: null,
            jsonKey: {
                name: 'cclone' + data.id,
                type: 'Cclone',
                subType: 'audience_cclone',
                ids: [toNumber(data.id)]
            }
        }
    },

    parseCcloneDetailsData: data => {
        let _data = {}
        for (const val of data) {
            const wamData = {
                end_day: val.end_day,
                id: toNumber(val.id),
                start_day: val.start_day,
                chartData: {
                    nonEmpty: utils.buildNonEmptyChartData(val.results.classifiers),
                    all: utils.buildAllEmptyChartData(val.results.classifiers)
                }
            }
            _data = { ..._data, ...wamData }
        }
        return _data
    },

    //This helper is here because of legacy cclone that don't match actual return format for positive and negative events
    /**
     * Will return the Json.parsed value if possible, in case of outdated cclone, will return basic value
     * @param {String} data Json stringified string
     * @returns {Number}
     */
    getCcloneInfo: (data, info) => {
        try {
            if (info) return JSON.parse(data)[info]
            return JSON.parse(data)
        } catch {
            return data
        }
    }
}
